module.exports = __webpack_public_path__ + "img/xampp.b4d3a089.png";